// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".van-sticky--fixed{position:fixed;top:0;right:0;left:0;z-index:1}", ""]);
// Exports
module.exports = exports;
